export var version = "3.12.11";
//# sourceMappingURL=version.js.map